// src/components/admin/NotificationCounter.js
import { useEffect, useRef } from 'react';
import axios from 'axios';
import { useNotification } from '../../context/NotificationContext';

const NotificationCounter = () => {
  const { updateTicketCount, updateLeadCount } = useNotification();
  const intervalRef = useRef(null);
  
  const fetchCounts = async () => {
    try {
      // Fetch ticket stats
      const ticketResponse = await axios.get('/api/tickets/admin/stats', {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      
      if (ticketResponse.data && ticketResponse.data.counts) {
        const openCount = ticketResponse.data.counts.open || 0;
        updateTicketCount(openCount);
      }
      
      // Fetch lead counts
      const leadResponse = await axios.get('/api/admin/leads', {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        params: { status: 'new', limit: 1 } // Minimal data needed for count
      });
      
      if (leadResponse.data) {
        // If your API returns a total count field
        if (leadResponse.data.total !== undefined) {
          updateLeadCount(leadResponse.data.total);
        } 
        // Otherwise count the items in the leads array
        else if (leadResponse.data.leads) {
          const newLeadsCount = leadResponse.data.leads.filter(l => l.status === 'new').length;
          updateLeadCount(newLeadsCount);
        }
      }
    } catch (error) {
      console.error('Error fetching notification counts:', error);
    }
  };
  
  useEffect(() => {
    // Fetch immediately on mount
    fetchCounts();
    
    // Set up interval to refresh counts (every 30 seconds)
    intervalRef.current = setInterval(fetchCounts, 30000);
    
    // Clean up interval on unmount
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);
  
  return null;
};

export default NotificationCounter;